import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"

// Connects to data-controller="flash"
export default class extends Controller {
  static targets = ["message"]

  connect() {
    this.showMessages()
  }

  showMessages() {
    this.messageTargets.forEach(message => {
      enter(message).then(() => {
        // Auto-dismiss after 5 seconds
        setTimeout(() => {
          this.dismissMessage(message)
        }, 5000)
      })
    })
  }

  dismiss() {
    this.messageTargets.forEach(message => this.dismissMessage(message))
  }

  dismissMessage(message) {
    leave(message).then(() => {
      message.remove()
      if (this.messageTargets.length === 0) {
        this.element.remove()
      }
    })
  }
}
